import { render } from "./Sizesmodal.vue?vue&type=template&id=c4431ac0"
import script from "./Sizesmodal.vue?vue&type=script&lang=js"
export * from "./Sizesmodal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__